export default class AnimationService {
    constructor() {
        if (window.matchMedia('(min-width: 999px)').matches) {
            AnimationService.strateInstagramParrallaxAnimation()
        }

        AnimationService.removeHeaderAnimatedClass()
        AnimationService.scrollReveal()
    }

    static removeHeaderAnimatedClass() {
        const $body = $('body')

        if ($body.hasClass('hp-header-animated')) {
            setTimeout(() => {
                $body.removeClass('hp-header-animated')
            }, 2500)
        }
    }

    static scrollReveal() {
        const ratio = 0.25
        const options = {
            root: null,
            rootMargin: '-50px',
            threshold: ratio,
        }

        const handleIntersect = (entries, observer) => {
            entries.forEach((e) => {
                if (e.intersectionRatio >= ratio) {
                    $(e.target).addClass('is-loaded')
                    observer.unobserve(e.target)
                }
            })
        }

        const observer = new IntersectionObserver(handleIntersect, options)

        document.querySelectorAll('[data-cx-animation]').forEach((el) => {
            observer.observe(el)
        })

        document.querySelectorAll('[data-animation]').forEach((el) => {
            observer.observe(el)
        })
    }

    static strateInstagramParrallaxAnimation() {
        $(window).on('load resize scroll', () => {
            let scrollTop = $(window).scrollTop()

            const $firstColumn = $('[data-element="column--1"]')
            const $secondColumn = $('[data-element="column--2"]')
            const $thirdColumn = $('[data-element="column--3"]')
            const $fourthColumn = $('[data-element="column--4"]')

            const $section = $('#strate-instagram-content')

            const colHeight = $secondColumn.outerHeight()

            const sectionOffset = $section.offset().top
            const yPosition = (scrollTop + 500 - sectionOffset) / 15
            const yPosition3 = (scrollTop + 500 - sectionOffset) / 10

            scrollTop = scrollTop + 800
            const yPosition2 = (scrollTop - 200 - sectionOffset) / 25

            if (scrollTop > sectionOffset && scrollTop < sectionOffset + colHeight) {
                $firstColumn.css({
                    transform: `translate3d(0, ${yPosition}px, 0)`,
                })

                $secondColumn.css({
                    transform: `translate3d(0, -${yPosition2}px, 0)`,
                })

                $thirdColumn.css({
                    transform: `translate3d(0, ${yPosition3}px, 0)`,
                })

                $fourthColumn.css({
                    transform: `translate3d(0, -${yPosition2}px, 0)`,
                })
            }
        })
    }
}
